module.exports = __webpack_public_path__ + "static/media/introduce-4.b4f0d0bf.png";